export default __webpack_public_path__ + "static/media/img_job_05.a262df67.jpg";